import { setExpiredAuth } from '../../../actions/ugMotorInsurance/quote';
import {
    apiTransitionOrderConfirmation,
    confirmOrderSuccess,
    confirmOrderFailure,
} from '../../../actions/ugMotorInsurance/payments';
import { getAccessToken, getIsConfirmOrderAPiPending } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { getCustomerIdValue, getSelectedCover } from '../../../selectors/ugMotorInsurance/quote';
import { COVER_PLANS } from '../../../actions/ugMotorInsurance/types';

export const orderConfirmationService = (store, next, action) => {
    (async () => {
        if (!getIsConfirmOrderAPiPending(store.getState())) {
            store.dispatch(apiTransitionOrderConfirmation.pending());
            try {
                const selectedCover = getSelectedCover(store.getState());

                let resp;

                if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                    resp = await confirmInsuranceOrder(store.getState());
                }

                if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                    resp = await confirmThirdPartyInsuranceOrder(store.getState());
                }

                if (resp.data) {
                    store.dispatch(confirmOrderSuccess(resp.data));
                    store.dispatch(apiTransitionOrderConfirmation.success());
                }

                return;
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionOrderConfirmation.failure());
                store.dispatch(confirmOrderFailure(e));
                return;
            }
        }
    })();
    return next(action);
};

const confirmOrderPayload = (state) => {
    const customerId = getCustomerIdValue(state);

    const payload = {
        id: customerId?.value,
    };

    return {
        ...payload,
    };
};

const confirmInsuranceOrder = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/order-confirmation';
        const response = await axios.post(url, confirmOrderPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
        return response;
    } catch (e) {
        // if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
        //     store.dispatch(setExpiredAuth(true));
        // }
        console.error(e);
        throw e;
    }
};

const confirmThirdPartyInsuranceOrder = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/third-party/order-confirmation';
        const response = await axios.post(url, confirmOrderPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
        return response;
    } catch (e) {
        // if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
        //     store.dispatch(setExpiredAuth(true));
        // }
        console.error(e);
        throw e;
    }
};
